var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group"},[_c('h4',{staticClass:"text-center"},[_vm._v("Sem pesquisas de preço para aprovação")]),_vm._v(" "),_c('div',{staticClass:"hr-line-dashed margin-top-5"})])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-413e3dde","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./FrontEnd/modulos/aprovar-pesquisa-preco/componentes/compartilhado/AprovarPesquisaPrecoSemLista.vue
// module id = 1992
// module chunks = 0